const hashCode = (str: string): number => {
  let hash = 2166136261;
  for (let i = 0; i < str.length; i++) {
    hash ^= str.charCodeAt(i);
    hash += (hash << 1) + (hash << 4) + (hash << 7) + (hash << 8) + (hash << 24);
  }
  return hash >>> 0;
};

const COMPACT_VIEW_ON_TOP_PERCENT = 50; // 50% of the users sees compact view option on top

export const isCompactViewOnTop = (identifier: string): boolean => {
  const hash = hashCode(identifier);
  return hash % 100 < COMPACT_VIEW_ON_TOP_PERCENT;
};
